import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import { Dialog, Table } from 'components';
import { useQuery } from 'hooks/useQuery';
import { emailSendingService } from 'services';

const columns = [{ label: 'Data/Hora' }, { label: 'Status' }, { label: 'Mensagem' }];

const statusLabels = {
  success: 'Enviado',
  no_data: 'Sem dados',
  error: 'Erro',
};

export const ViewLogsDialog = ({ open, handleClose, config = {} }) => {
  const [logs, , loadingLogs] = useQuery(
    () => (config?.id ? emailSendingService.listLogs(config.id) : Promise.resolve({ data: [] })),
    [config?.id],
  );

  if (!open) return null;

  return (
    <Dialog maxWidth='sm' scroll='paper' onClose={handleClose} open={open}>
      <Dialog.Title onClose={handleClose}>
        Log de envio {config?.title ? `— ${config.title}` : ''}
      </Dialog.Title>
      <Dialog.Content>
        <Table
          headers={columns}
          striped
          emptyMessage='Nenhum envio registrado ainda.'
          data={logs}
          loading={loadingLogs}
          disableNumeration
        >
          {(logs || []).map((log) => (
            <TableRow key={log.id}>
              <TableCell>{new Date(log.sent_at).toLocaleString('pt-br')}</TableCell>
              <TableCell>
                <Typography
                  variant='body2'
                  color={
                    log.status === 'error'
                      ? 'error'
                      : log.status === 'no_data'
                      ? 'textSecondary'
                      : 'primary'
                  }
                >
                  {statusLabels[log.status] || log.status}
                </Typography>
              </TableCell>
              <TableCell>{log.message}</TableCell>
            </TableRow>
          ))}
        </Table>
      </Dialog.Content>
    </Dialog>
  );
};
